import { FunctionComponent, useEffect } from 'react'

declare global {
  interface Window {
    AfterpayReactNativeWebView?: {
      postMessage?: (message: string, targetOrigin: string) => void
    }
  }
}

export const postMessageToInAppBrowser = (message: string): void => {
  window.AfterpayReactNativeWebView?.postMessage?.(message, '/')
}

export const CHECKOUT_FLOW_TYPE = {
  ON_SIGNUP_START: 'onSignUpStart',
  ON_SIGNUP_COMPLETE: 'onSignUpComplete',
  ON_ORDER_COMPLETE: 'onOrderComplete',
  ON_CHECKOUT_LOADED: 'onCheckoutLoaded',
  ON_CHECKOUT_ERROR: 'onCheckoutError',
  ON_CHECKOUT_UNLOAD: 'onCheckoutUnload',
  ON_GIFT_CARD_CLOSE: 'onGiftCardClose',
  ON_IDV_DECLINED: 'onIDVDeclined',
} as const

export const postCheckoutFlowMessage = (type: string, payload = {}): void => {
  const message = JSON.stringify({
    type,
    payload,
  })
  postMessageToInAppBrowser(message)
}

export const postRoktMessage = (): void => {
  const message = JSON.stringify({
    type: 'checkoutCompleted',
    payload: {},
  })
  postMessageToInAppBrowser(message)
}

export const RoktMessenger: FunctionComponent = () => {
  const postRoktMessage = (): void => {
    const message = JSON.stringify({
      type: 'checkoutCompleted',
      payload: {},
    })
    postMessageToInAppBrowser(message)
  }

  useEffect(() => {
    postRoktMessage()
  }, [])

  return null
}
